import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FaExclamationTriangle } from 'react-icons/fa';

const ErrorModal = ({ show, handleClose, errorMessage }) => {
  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Body className="text-center">
        <FaExclamationTriangle size={100} color="red" className="mb-3" />
        <h5>{errorMessage}</h5>
        <Button 
          variant="danger" 
          onClick={handleClose} 
          className="mt-3"
        >
          Fechar
        </Button>
      </Modal.Body>
    </Modal>
  );
};

export default ErrorModal;